import React from 'react';
import { Text, Box } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import noTaskFound from 'assets/noTaskFound.png';

export const EmptyView = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={['spacing.8', 'spacing.6']}>
      <img
        width="150px"
        height="150px"
        src={getStaticMediaUrl(noTaskFound)}
        alt="You’re all caught up!"
      />
      <Text
        size="medium"
        color="surface.text.gray.muted"
        marginTop="spacing.4"
        marginBottom="spacing.2">
        You're all caught up!
      </Text>
      <Text size="small" color="surface.text.gray.muted" marginBottom="spacing.4">
        No pending requests to show
      </Text>
    </Box>
  );
};
